import { useQuery } from '@tanstack/react-query';
import { formBuilderApi, formBuilderKeys } from '@/features/quote-and-apply-builder';

export function useCarrierForms(insuranceCarrierId: number) {
  return useQuery({
    queryKey: formBuilderKeys.list({ carrierId: insuranceCarrierId }),
    queryFn: () => formBuilderApi.getFormsByCarrierId(insuranceCarrierId),
  });
}
